import * as Yup from "yup";

export const depositSchema = (intl) => {
  return Yup.object().shape({
    amount: Yup.string()
      .nullable(false)
      .required(intl.formatMessage({ id: "amountRequired" })),
  });
};
